
import { computed, defineComponent, ref, onMounted } from "vue";
import { useStore } from "vuex";
import CertificationCard from "@/components/certification/CertificationCard.vue";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "certification-list",
  components: {
    CertificationCard
  },
  setup() {
    const store = useStore();
    const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
    
    const certifications = ref<any[]>([]);
    const filteredCertifications = ref<any[]>([]);
    const searchQuery = ref("");
    const loading = ref(false);

    const loadCertifications = async () => {
      loading.value = true;
      try {
        const { data, status } = await ApiService.get('/certification');
        if (status === 200) {
          certifications.value = data.data || [];
          filteredCertifications.value = certifications.value;
        }
      } catch (error) {
        console.error("Erro ao carregar certificações:", error);
        certifications.value = [];
        filteredCertifications.value = [];
      } finally {
        loading.value = false;
      }
    };

    const filterCertifications = () => {
      if (!searchQuery.value) {
        filteredCertifications.value = certifications.value;
        return;
      }

      const query = searchQuery.value.toLowerCase().trim();
      filteredCertifications.value = certifications.value.filter(cert => 
        cert.name.toLowerCase().includes(query) ||
        cert.description.toLowerCase().includes(query) ||
        cert.level.toLowerCase().includes(query)
      );
    };

    const clearSearch = () => {
      searchQuery.value = "";
      filterCertifications();
    };

    onMounted(async () => {
      await loadCertifications();
    });

    return {
      certifications,
      filteredCertifications,
      searchQuery,
      loading,
      currentLanguage,
      filterCertifications,
      clearSearch
    };
  }
});
